import Dexie, { Table } from 'dexie';
import { FarmModel } from '../models/farm.model';
import { MemberModel } from '../models/member.model';

export interface TodoList {
    id?: number;
    title: string;
  }
  export interface TodoItem {
    id?: number;
    todoListId: number;
    title: string;
    done?: boolean;
  }

  export interface GenericItem {
    id?: number;
    tablename?: string;
    value:any;
  }

  export class AppDB extends Dexie {
    todoItems!: Table<TodoItem, number>;
    todoLists!: Table<TodoList, number>;
    genericItems!: Table<GenericItem, number>;
    regProfile!: Table<MemberModel, number>;
    regFarm!: Table<FarmModel, number>;
    
    constructor() {
      super('patgOnlineDB');
      this.init();
    }

    public init(){      
      this.version(3).stores({
        regProfile: 'memberIC',
        regFarm: '++farmId',
        regFarmWorker: '++farmWorkerId',
        todoLists: '++id',
        todoItems: '++id, todoListId',
        genericItems:'auto_id,tablename,[tablename+cardId],[tablename+farmId],[tablename+cardStatus],[tablename+memberId],[tablename+farmIsOwned],[tablename+farmIsWorked],[tablename+farmIsOwned+farmIsWorked],[tablename+stateId],[tablename+districtId],[tablename+parlimen_id],[tablename+ips_year+ips_month]',
      });
        
      this.on('populate', () => this.populate());
    }
  
    async populate() {
      const username = localStorage.getItem('username');
      if(username !== null){
        // add temporary table for member registration
        let memberModel: MemberModel = {} as MemberModel;
        memberModel.memberIC = username;
        await db.regProfile.add(memberModel);

        // add temporary table for Farm registration
        let farmModel: FarmModel = {} as FarmModel;
        farmModel.farmId = 1;
        await db.regFarm.add(farmModel);

      }
      
      const todoListId = await db.todoLists.add({
        title: 'To Do Today',
      });

      
      //await this.populateCard();
      //await this.populateFarm();

      await db.todoItems.bulkAdd([
        {
          todoListId,
          title: 'Feed the birds',
        },
        {
          todoListId,
          title: 'Watch a movie',
        },
        {
          todoListId,
          title: 'Have some sleep',
        },
      ]);
    }


    public async populateMemberInfo(){
      // this.memberService.getList().subscribe(data=> {
      //   this.member=data;
      //   let obj:any={};
      //   obj['tablename']="member";
      //   obj['id']=this.member.memberid;
      //   obj['value']=this.member;
      //  // console.log(obj);
      //   db.genericItems.add(obj);
      //  // console.log(this.member.memberName);
      //   //this.member=new MemberModel({data.toString()});
      //   //console.log(this.member.memberName);
      // });
    }

    
    

    async populateCard(){
        var jsonStr='[{"cardid":1,"cardno":"C/01/01/00001"},{"cardid":10,"cardno":"C/01/01/00002"}]';
        var dList = JSON.parse(jsonStr);
        dList.forEach(function(item:any, index:any){
          item['tablename']='card';
          item['auto_id']="card_" + item.cardid;
        });  
        //console.log(dList[0]);
        await db.genericItems.bulkAdd(dList);
    }

    async populateFarm(){
        var jsonStr='[{"farmid":1,"no_geran":"F00001"},{"farmid":5,"no_geran":"F00002"}]';
        var dList = JSON.parse(jsonStr);
        dList.forEach(function(item:any, index:any){
          item['tablename']='farm';
          item['auto_id']="farm_"+item.farmid;
        });  
        //console.log(dList[0]);
        await db.genericItems.bulkAdd(dList);
    }

  }
  
  export const db = new AppDB();